<template>
    <div>
        <div v-if="!isMobile" class="vendeurinfoboard">
            <div class="headBox">
                <div class="proMsg">
                    <!-- <img :src="data.logo?data.logo:require('../assets/img/productDetail/logo.png')" alt="" class="logo"> -->
                    <div class="uc">
                        <el-image :lazy='true' :src="dataAll.logo" alt
                                  class="logo el-link"
                                  style="height: 6vw;width: 143px"
                                  @click="$router.push(this.vid)"
                                  fit="scale-down">
                            <div slot="error" style="text-align: center;margin-top: 2.8vw">
                                <span>{{ dataAll.nomBoutique }}</span>
                            </div>
                        </el-image>
                        <div class="info">
                            <div class="name">{{
                                    langPage['vendeurs-informations']['TXT_membredepuisle'] | toUpperCase
                                }}
                            </div>
                            <div class="value" v-if="dataAll&&dataAll.dateCreation">
                                {{ formatDate(dataAll.dateCreation, '{d}-{m}-{y}') }}
                            </div>
                        </div>
                        <div class="info">
                            <div class="name">{{ langPage['v4-vendeurinfo']['TXT_dernierupload'] }}</div>
                            <div class="value">
                                {{ formatDate(last_update_produits_time, '{d}-{m}-{y}') }}
                            </div>
                        </div>
                        <!--                    <div class="info">-->
                        <!--                        <div class="name">Délais moyens</div>-->
                        <!--                        <div class="value">{{dataAll.delay_moyen + ' jours'}}</div>-->
                        <!--                    </div>-->
                        <div class="info">
                            <div class="name">{{ langPage['v4-marqueslist']['TXT_commandeminimum'] }}</div>
                            <div class="value" v-if="dataAll && (dataAll.commandeMini||dataAll.commandeMini==0)">
                                {{ dataAll.commandeMini }} €
                            </div>
                        </div>
                    </div>
                    <div class="uc">
                        <!-- 实心取消 -->
                        <img v-if="dataAll.isCollect" src="../assets/img/loving_heart.svg" class="like"
                             @click.stop="addFavorite"/>
                        <img v-else src="../assets/img/loving_heart_n.svg" class="like"
                             @click.stop="addFavorite"/>
                        <!-- 空心添加 -->
                        <!-- <img src="../assets/img/loving_heart_n.svg" class="like"
                        @click.stop="addFavorite">-->
                        <!-- v-if="!(data&&data.isCollect)" -->
                        <!-- 信封 -->
                        <div @click.stop="show = !show" class="sel-arrow">
                            <span>{{ langPage['v4-vendeurinfo']['TXT_ensavoirplus'] }}</span>
                            <img src="../assets/img/arrow-down.svg" alt/>
                        </div>
                    </div>
                </div>
            </div>
            <slot></slot>
            
            <div class="container">
                <div class="verduarBox" v-if="show && $store.state.token">
                    <p class="divider"/>
                    <ul class="top">
                        <li :class="[current === 1?'active':'']" @click.stop="current = 1">Informations</li>
                        <li :class="[current === 2?'active':'']" @click.stop="current = 2">Promotions</li>
                    </ul>
                    <ul class="bottom" v-if="current==1">
                        <li style="width:37%">
                            <!--                        <div class="title">About SWEEWË</div>-->
                            <div>{{ dataAll.vendeurs_langues[0].description }}</div>
                        </li>
                        <li v-if="catalogues && catalogues.length>0" style="width:21%;padding:0 20px;">
                            <div class="title">{{ langPage['v4-vendeurinfo']['TXT_typedevetements'] }}</div>
                            <template>
                                <div v-for="(item,index) in catalogues" :key="index">{{ item }}</div>
                            </template>
                        </li>
                        <li style="width:21%;padding:0 20px;">
                            <div class="title">{{ langPage['mobile-produits']['TXT_adresse'] }}</div>
                            <div v-if="dataAll.adresses[0]">
                                {{
                                    dataAll.adresses[0].numero + ' ' + dataAll.adresses[0].rue
                                    + ' ' + dataAll.adresses[0].codePostal
                                }}
                            </div>
                            <div v-if="dataAll.adresses[0]">
                                {{ dataAll.adresses[0].ville }}
                            </div>
                        </li>
                        <!--                    <li style="width:21%">-->
                        <!--                        <div class="title">CONTACT</div>-->
                        <!--                        <div v-if="dataAll.email">{{dataAll.email}}</div>-->
                        <!--                        <div v-if="dataAll.adresses[0].telephone||dataAll.adresses[0].mobile">-->
                        <!--                            {{dataAll.adresses[0].telephone ? dataAll.adresses[0].telephone :-->
                        <!--                            dataAll.adresses[0].mobile}}-->
                        <!--                        </div>-->
                        <!--                        <img v-if="vendeur_contact_data['social-url'].instagram" class="icon"-->
                        <!--                             style="margin-top: 1vw;cursor: pointer"-->
                        <!--                             src="@/assets/img/bottom/Instagram.svg"-->
                        <!--                             @click.stop="onContactIconClick(vendeur_contact_data['social-url'].instagram)" alt=""/>-->
                        <!--                        <img v-if="vendeur_contact_data['social-url'].facebook" class="icon"-->
                        <!--                             style="margin-left: 0.5vw;cursor: pointer"-->
                        <!--                             src="@/assets/img/bottom/Facebook.svg"-->
                        <!--                             @click.stop="onContactIconClick(vendeur_contact_data['social-url'].facebook)" alt=""/>-->
                        <!--                    </li>-->
                    </ul>
                    <ul class="bottom" v-if="current==2"
                        :style="{'justify-content':discountList.length==0?'space-between':'','flex-wrap':discountList.length==0?'wrap':''}">
                        <template v-if="discountList.length>0">
                            <li v-for="item of discountList" :key="item.id_remise">
                                <div :class="{ bg1:item.type==='pourcentage', bg2:item.type!=='pourcentage' }">
                                    <div>{{ langPage['v4-vendeurinfo']['TXT_couponspecial'] }}</div>
                                    <div v-if="item.code" class="btn">{{ item.code }}</div>
                                    <div>{{ getCouponDescription(item) }}
                                    </div>
                                </div>
                            </li>
                        </template>
                        <template v-else>
                            <div v-show="!currDiscount" style="width:100%;margin-bottom:25px;font-weight:bold">
                                {{ langPage['v4-vendeurinfo']['TXT_encemoment'] }}
                            </div>
                            <div class="item threeRows" v-for="(item,i) in currDiscount" :key="i">
                                <div class="rel">
                                    <div :style="{'width':'220px','min-height':'336px',
                                'background-image':`url('${$common.imgHost}Images/Boutiques/${item.id_vendeur}/Produits/fiche/${item.id_produit}-c.jpg')`,
                                }" style="background-size: cover;position: relative;cursor: pointer"
                                         @click.stop="goDetail(item)">
                                    <span class="remise-precent" v-if="item.prixReduit">
                                        {{
                                            -((Number(item.prix).del(item.prixReduit) / item.prix) * 100).toFixed(0) + '%'
                                        }}
                                    </span>
                                        <span class="Nouveau">
                                        {{ langPage['grossistes-liste-recherche']['TXT_new'] }}
                                    </span>
                                    </div>
                                </div>
                                <div>
                                    <p class="font12">
                                        {{
                                            item.vendeurs_marque.nom_marque ? item.vendeurs_marque.nom_marque : langPage['v4-collapse']['TXT_not_brand_name']
                                        }}
                                    </p>
                                    <p class="font14">{{
                                            item.reference ? item.reference : langPage['v4-collapse']['TXT_not_prod_name']
                                        }}</p>
                                    <div class="price">
                                <span :class="item.prixReduit?'line-through':''" class="font14">
                                    {{ item.prix }} € HT
                                </span>
                                        <span v-if="item.prixReduit" class="font14" style="margin-left:10px;color:red">
                                    {{ item.prixReduit }} € HT
                                    </span>
                                    </div>
                                    <p class="font12">{{ $t(`goods_list.${item.vendu_par}`) }}</p>
                                </div>
                            </div>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="isMobile" class="mVendeurinfoboard mobileCommon">
            <div class="mheadBox" align="center">
                <el-row type="flex" class="mproMsg" align="middle">
                    <el-image :lazy='true' :src="dataAll.logo" alt class="mlogo"
                              @click="$router.push('/vendeur/'+vid)"
                              fit="scale-down">
                        <div slot="error" style="text-align: center;padding-top: 20%">
                            <span class="vendeurName">{{ dataAll.nomBoutique }}</span>
                        </div>
                    </el-image>
                    <!-- 实心取消 -->
                    <img v-if="dataAll.isCollect" src="../assets/img/loving_heart.svg" class="mlike"
                         @click.stop="addFavorite"/>
                    <img v-else src="../assets/img/loving_heart_n.svg" class="mlike"
                         @click.stop="addFavorite"/>
                </el-row>
                <div @click.stop="show = !show" class="msel-arrow">
                    <span>En savoir plus sur la marque</span>
                    <img src="../assets/img/arrow-down.svg" alt/>
                </div>
            </div>
            <slot></slot>
            <div class="mcontainer">
                <div class="verduarBox" v-if="show && $store.state.token">
                    <div class="info">
                        <div class="name">{{
                                langPage['vendeurs-informations']['TXT_membredepuisle'] | toUpperCase
                            }}
                        </div>
                        <div class="value" v-if="dataAll&&dataAll.dateCreation">
                            {{ formatDate(dataAll.dateCreation, '{d}-{m}-{y}') }}
                        </div>
                    </div>
                    <div class="info">
                        <div class="name">{{ langPage['v4-vendeurinfo']['TXT_dernierupload'] }}</div>
                        <div class="value">
                            {{ formatDate(last_update_produits_time, '{d}-{m}-{y}') }}
                        </div>
                    </div>
                    <div class="info">
                        <div class="name">{{ langPage['v4-marqueslist']['TXT_commandeminimum'] }}</div>
                        <div class="value" v-if="dataAll && (dataAll.commandeMini||dataAll.commandeMini==0)">{{
                                dataAll.commandeMini
                            }} €
                        </div>
                    </div>
                    <p class="divider" style="margin: 24px 0;"/>
                    <ul class="top">
                        <li :class="[current === 1?'active':'']" @click.stop="current = 1">Informations</li>
                        <li :class="[current === 2?'active':'']" @click.stop="current = 2">Promotions</li>
                    </ul>
                    <ul class="bottom" v-if="current==1">
                        <li>
                            <!--                        <div class="title">About SWEEWË</div>-->
                            <div>{{ dataAll.vendeurs_langues[0].description }}</div>
                        </li>
                        <li v-if="catalogues && catalogues.length>0" style="width:21%;padding:0 20px;">
                            <div class="title">{{ langPage['v4-vendeurinfo']['TXT_typedevetements'] }}</div>
                            <template>
                                <div v-for="(item,index) in catalogues" :key="index">{{ item }}</div>
                            </template>
                        </li>
                        <li>
                            <div class="title">{{ langPage['mobile-produits']['TXT_adresse'] }}</div>
                            <div v-if="dataAll.adresses[0]">
                                {{
                                    dataAll.adresses[0].numero + ' ' + dataAll.adresses[0].rue
                                    + ' ' + dataAll.adresses[0].codePostal
                                }}
                            </div>
                            <div v-if="dataAll.adresses[0]">
                                {{ dataAll.adresses[0].ville }}
                            </div>
                        </li>
                    </ul>
                    <ul class="bottom" v-if="current==2"
                        :style="{'justify-content':discountList.length==0?'space-between':'','flex-wrap':discountList.length==0?'wrap':''}">
                        <template v-if="discountList.length>0">
                            <li v-for="item of discountList" :key="item.id_remise">
                                <div :class="{ bg1:item.type==='pourcentage', bg2:item.type!=='pourcentage' }">
                                    <div>{{ langPage['v4-vendeurinfo']['TXT_couponspecial'] }}</div>
                                    <div v-if="item.code" class="btn">{{ item.code }}</div>
                                    <div>{{ getCouponDescription(item) }}
                                    </div>
                                </div>
                            </li>
                        </template>
                        <template v-else>
                            <div v-show="!currDiscount" class="discountDesc">
                                {{ langPage['v4-vendeurinfo']['TXT_ensavoirplus'] }}
                            </div>
                            <goodsList ref="goodList" @goDetail="goDetail" :rows="1" :list="currDiscount" type="0">
                            </goodsList>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 商家信息条
 */
import goodsList from "../components/goodsList";

let formatUtils = require('../utils/format');
let moment = require('moment');
export default {
    name: "vendeurInfoBoard",
    props: {
        vendeurData: Object,//商家数据
    },
    components: {
        goodsList
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            loading: false,
            menuList: [
                {key: "prix_asc", value: "价格升序"},
                {key: "prix_desc", value: "价格降序"},
                {key: "date_creation_asc", value: "创建时间升序"},
                {key: "date_creation_desc", value: "创建时间降序 "}
            ], //下拉框所有条件
            order: {key: "date_creation_desc", value: "创建时间降序"},
            offset: 0,
            description: "", //商家描述
            currDiscount: [],//最近打折商品
            discountList: [], //折扣商品(对应有背景图的两个模块，如果这块数据没有直接渲染最近打折的商品)
            pages: 1,
            TotalCount: 0,
            busy: false,
            limit: 10,
            count: "", //一共多少个结果
            activeName: "0",
            show: false, //是否展示更多商家信息
            rows: 4,
            current: 1,
            list: [],
            topList: [],
            color: [],
            vid: "",
            categorie_id: "",
            totleDate: [],
            promotion: [], //打折百分比,
            linksroute: [],
            dataAll: {},
            catalogues: [], //商家经营目录
            bgList: [
                require("../assets/img/home/bg04.svg"),
                require("../assets/img/home/ver_bg.png")
            ],
            filterList: {
                id_langue: localStorage.getItem("lang") || "fr", //语言
                vendu_par: "", //销售方式
                new: "", //是否为新品 1 0
                favoris: "", //是否为收藏
                reference: "", //货号
                prix_debut: "", //起始价格
                prix_fin: "", //最高价格
                promotion_debut: "", //打折最低价格
                promotion_fin: "", //打折最高价格
                provenances: [], //产地
                vendeurs: "", //商家
                marques: [], //品牌
                collections: [],
                promotions: [],
                compositions: [], //产品成分
                caracteristiques: [], //产品特性
                tendances: "", //品趋势
                couleurs: [], //产品颜色
                order: "date_creation_desc",
                categories: [] //产品类型
            },
            vendeur_contact_data: {},//商家的联系数据，包括facebook等
            support_categories_ids: [], //商家支持的最顶级的产品类型
            is_show_loadMore: true,
            mVendeurData: {},
            last_update_produits_time: '',
            formatDate: formatUtils.parseTime,
        }
    },
    created() {
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    watch: {
        vendeurData(value) {
            this.convertData(value);
        }
    },
    mounted() {
        //需要在初始化和监听venduerData数据的变化，因为如果是异步获取的数据，第一次传进来的数据是空的
        this.convertData(this.vendeurData);
    },
    filters: {
        dateSubstring(value) {
            return value.slice(0, 10);
        },
        toUpperCase(val) {
            if (!val) return "";
            return val.toUpperCase();
        },
    },
    methods: {
        onContactIconClick(url) {
            window.open(url, '_blank')
        },
        //获取商家的优惠活动
        getDiscount() {
            let th = this;
            this.$api.order.getDiscount({
                page: 1,
                pageSize: "100",
                remiseType: "remise",
                isCollect: th.dataAll.isCollect,
                idVendeur: th.vid
            }).then(res => {
                this.discountList = res.data.list;
                if (res.data.list.length < 1) {
                    th.getProduction();
                }
            });
        },
        //获取优惠券的描述
        getCouponDescription(remise) {
            let description = 'Ce coupon est ';
            // '本优惠券是 实际金额折扣/百分比折扣 类型， 最低满100/最高满1000/无满减限制 ,可以减免 100元/10%,有效期为2010-2022/无有效期';
            if (remise.type === 'pourcentage') {
                description += 'Pourcentage de réduction type,'
            } else description += 'Décote sur le montant réel type,';
            if (remise.montant_min) description += `minimum ${remise.montant_min},`;
            if (remise.montant_max) description += `Jusqu’à ${remise.montant_max},`;
            if (!remise.montant_min && !remise.montant_max) description += 'Pas de limitation du montant à utiliser,';
            description += `Réduction ${remise.montant} ${remise.type === 'pourcentage' ? '%' : '€'},`;
            if (remise.date_debut) description += `Valable pour ${moment(remise.date_debut).format('DD-MM-yyyy')} `;//this.xxx + remise.date_debut
            if (remise.date_fin) description += `Valable jusqu’au ${moment(remise.date_fin).format('DD-MM-yyyy')} `;
            if (!remise.date_debut && !remise.date_fin) description += `Pas de limitation dans le temps`;
            return description;
        },
        //没有打折产品获取最近打折的商品
        getProduction() {
            this.$api.order.getProduction({
                page: 1,
                pageSize: "5",
                type: "others",
                id_vendeur: this.vid
            })
                .then(res => {
                    this.currDiscount = res.data.list;
                })
        },
        addFavorite() {
            if (!this.$store.state.token) {
                return this.$message.error(this.$t("seller_marques.word3"));
            }
            let params = {};
            params.id_vendeur = this.vid;
            params.id_acheteur = localStorage.getItem("id_acheteur");
            let marqueIds = [];
            for (let marque of this.dataAll.vendeurs_marques) {
                marqueIds.push(marque.id_vendeur_marque);
            }
            params.id_vendeur_marques = marqueIds.join(',');
            this.$api.favor.addSellerMarques(params).then(res => {
                if (res.code !== 0) {
                    return this.$message.error(res.message);
                }
                if (res.data.supprimer === 0) {
                    this.$message.success(this.$t("seller_marques.word1"))
                    this.dataAll.isCollect = 1;
                } else {
                    this.$message.success(this.$t("seller_marques.word2"))
                    this.dataAll.isCollect = 0;
                }
                this.$forceUpdate();
            })
        },
        //转化传进来的数据
        convertData(data) {
            if (this.vendeurData.length < 1) return;
            this.dataAll = Object.assign(data);
            this.vid = this.dataAll.id_vendeur;
            let vendeursData = this.dataAll.vendeurs_datum.data;
            try {
                vendeursData = JSON.parse(vendeursData);
                this.vendeur_contact_data = vendeursData;
                this.getDiscount();
                if (this.dataAll.vendeurs_datum.last_update_produits_time) {
                    this.last_update_produits_time = this.dataAll.vendeurs_datum.last_update_produits_time;
                }
            } catch (e) {
                this.vendeur_contact_data = {};
            }
        },
        goDetail(item) {
            let url = window.origin + `/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`
            window.open(url, '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
.marques {
    font-family: Ogg-Roman;
    background-color: #f6f3f1;
    box-sizing: border-box;
    // padding: 0 64px;
    .router {
        padding-left: 0.5rem;
    }

    .banners {
        width: 100%;
        padding: 0 0.5rem;
        margin-top: 22px;
        margin-bottom: 14px;

        img {
            width: 100%;
        }
    }

    .headBox {
        position: relative;
    }

    .container {
        position: relative;
        height: auto;
        // display: flex;
        background: transparent;
        // padding:0.9rem 0;
        .verduarBox {
            background-color: #ffffff;
            padding: 0px 30px 32px;
            width: 100%;
            position: absolute;
            z-index: 1000;
            top: 0;
            left: 0;
            right: 0;
            //border: 1px solid;
            margin: 0 auto;
            font-size: 14px;

            .top {
                margin-bottom: 20px;

                li {
                    cursor: pointer;
                    display: inline-block;
                    font-size: 14px;
                    font-weight: bold;
                    padding-bottom: 10px;
                }

                li:first-child {
                    margin-right: 30px;
                }

                .active {
                    border-bottom: 2px solid;
                }
            }

            .bottom {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                overflow-y: scroll;
                max-height: 480px;

                li {
                    display: inline-block;
                    width: 25%;
                    line-height: 25px;
                }

                .bg1,
                .bg2 {
                    width: 304px;
                    height: 380px;
                    padding: 0 10px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    div {
                        width: 100%;
                        text-align: center;
                        font-size: 14px !important;
                    }

                    div:first-child {
                        font-weight: bold;
                    }

                    .btn {
                        width: 200px;
                        height: 48px;
                        line-height: 48px;
                        background: black;
                        color: #fff;
                        text-align: center;
                        margin: 15px auto;
                    }
                }

                .bg1 {
                    background: url("../assets/img/bg1.svg") no-repeat center center;
                    background-size: cover;
                }

                .bg2 {
                    background: url("../assets/img/bg2.svg") no-repeat center center;
                    background-size: cover;
                }

                .title {
                    font-weight: 600;
                }

                .subTitle {
                    text-align: left;
                    margin-top: 15px;
                    font-weight: bold;
                }

                .item {
                    width: 20%;
                    margin-bottom: 20px;
                }
            }

            .divider {
                margin-bottom: 20px;
                background: #DCDFE6;
                width: 100%;
                height: 1px;
            }
        }

        .proBox {
            padding-top: 30px;
            display: flex;

            .filter {
                flex-grow: 0;
                width: 2.5rem;
                padding-left: 0.5rem;

                .coupon {
                    margin-top: 0.42rem;
                    width: 100%;
                    height: 2.58rem;
                    position: relative;
                    background: url("../assets/img/vendeur/bg_3.png") no-repeat center;
                    background-size: cover;
                    padding-top: 0.72rem;
                    box-sizing: border-box;

                    img:nth-child(1) {
                        width: 100%;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }

                    img:nth-child(2) {
                        width: 65%;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }

                    > div {
                        text-align: center;
                        position: relative;
                        z-index: 10;

                        .friday {
                            font-size: 10px;
                            font-weight: bold;
                        }

                        .btn {
                            width: 1.5rem;
                            height: 0.36rem;
                            background: #000000;
                            color: #ffffff;
                            text-align: center;
                            line-height: 0.36rem;
                            margin: 12px auto;
                            font-size: 12px;
                        }

                        p {
                            font-size: 10px;
                            line-height: 15px;
                        }
                    }
                }
            }

            .list {
                flex: 1;
                width: calc(100% - 2.5rem);
                // border:1px solid blue;
                padding: 0 0.36rem;

                .conditions {
                    height: 30px;
                    line-height: 30px;
                    vertical-align: bottom;

                    .condition {
                        height: 30px;
                        line-height: 30px;
                        padding: 0 12px;
                        font-size: 14px;
                        font-family: MaisonNeue-Medium;
                        border-radius: 15px;
                        background-color: #ffffff;
                        display: inline-block;
                        vertical-align: bottom;

                        .close {
                            width: 10px;
                        }
                    }

                    .clear {
                        margin-left: 15px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 14px;
                        font-family: MaisonNeue-Medium;
                        display: inline-block;
                        vertical-align: bottom;
                    }
                }

                .screen {
                    /*height: 20px;*/
                    /*line-height: 20px;*/
                    vertical-align: middle;
                    font-size: 0;
                    margin: 0 0 30px;
                    padding-right: 0.5rem;

                    .nav {
                        display: inline-block;
                        width: 50%;

                        .rows {
                            display: inline-block;
                            margin-right: 15px;
                        }

                        .num {
                            display: inline-block;
                            font-size: 14px;
                            font-family: MaisonNeue-Medium;
                            margin-right: 15px;
                        }

                        .name {
                            display: inline-block;
                            font-size: 14px;
                            font-family: MaisonNeue-Light;
                            margin-right: 15px;
                        }

                        .value {
                            display: inline-block;
                            font-size: 14px;
                            font-family: MaisonNeue-Medium;
                            margin-right: 15px;
                        }
                    }
                }

                .infinite-list {
                    // height: 6rem;
                    overflow-y: scroll;
                    padding-right: 0.5rem;
                }

                .saleBox {
                    margin-bottom: 30px;
                    margin-top: 25px;

                    .content {
                        text-align: center;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        color: #ffffff;
                        justify-content: center;
                        height: 100%;

                        h3 {
                            line-height: 0.4rem;
                        }

                        .whiteBtn {
                            margin: 30px 0 20px 0;
                            border: 1px dashed #ffffff;
                            display: inline-block;
                            cursor: pointer;
                            color: #ffffff;
                        }

                        .tip {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }

    .proMsg {
        height: 1rem;
        vertical-align: middle;
        background-color: #ffffff;
        padding: 0 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 20000;

        .uc {
            display: flex;
            align-items: center;
            justify-content: space-between;

            & > img {
                margin-right: 30px;
                width: 180px;
                height: 104px;
            }

            .like {
                width: 23px;
                height: 20px;
                margin: 0 10px;
            }

            .msg {
                width: 24px;
                height: 24px;
                margin: 0 10px;
                margin-right: 32px;
            }

            .sel-arrow {
                display: flex;
                justify-content: space-around;
                border: 1px solid #000000;
                color: black;
                width: 244px;
                height: 48px;
                line-height: 48px;
                padding-left: 10px;
                font-size: 10px;
                cursor: pointer;

                span {
                    vertical-align: middle;
                    font-family: MaisonNeue-Medium;
                    font-weight: bold;
                }

                img {
                    vertical-align: middle;
                    margin: auto;
                    width: 8px;
                    height: 8px;
                }
            }
        }

        .logo {
            vertical-align: middle;
        }

        .info {
            display: inline-block;
            margin: 0 32px;

            div {
                height: 50%;

                text-align: center;
            }

            .name {
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 10px;
            }

            .value {
                font-weight: normal;
                font-size: 14px;
            }
        }
    }
}

.icon {
    /* 通过设置 font-size 来改变图标大小 */
    width: 2vw;
    /* 图标和文字相邻时，垂直对齐 */
    vertical-align: -0.15em;
    /* 通过设置 color 来改变 SVG 的颜色/fill */
    fill: black;
    /* path 和 stroke 溢出 viewBox 部分在 IE 下会显示
       normalize.css 中也包含这行 */
    overflow: hidden;
}

.line-through {
    text-decoration: line-through;
}

.vendeurinfoboard {
    .remise-precent {
        position: absolute;
        right: 10px;
        bottom: 20px;
        background-color: white;
        color: red;
        padding: 3px 8px;
        font-size: 12px;
    }

    .Nouveau {
        position: absolute;
        left: 10px;
        bottom: 20px;
        background-color: black;
        color: white;
        padding: 3px 8px;
        font-size: 12px;
    }
}

.mVendeurinfoboard {
    background-color: white;
    width: 88vw;
    //margin-left: 6vw;
    padding: 6.4vw;

    .mheadBox {
        padding-bottom: 3vw;

        .mproMsg {

            .mlogo {
                height: 22.5vw;
                width: 45vw;
                margin-left: 10vw;

                .vendeurName {
                    font-size: 12pt;
                }
            }

            .mlike {
                margin-left: 10vw;
            }

        }

        .msel-arrow {
            justify-content: space-around;
            border: 1px solid #000000;
            color: black;
            width: 100%;
            height: 48px;
            line-height: 48px;
            padding-left: 10px;
            font-size: 10pt;
            cursor: pointer;

            span {
                vertical-align: middle;
                font-family: MaisonNeue-Medium;
                font-weight: bold;
            }

            img {
                vertical-align: middle;
                padding-left: 10vw;
            }
        }
    }

    .mcontainer {
        .verduarBox {
            padding: 3vw 0vw;

            .info {
                margin-bottom: 16px;

                .name {
                    font-size: 10pt;
                    line-height: 24px;
                    font-weight: bold;
                }

                .value {
                    font-size: 10pt;
                    line-height: 24px;
                }
            }

            .top {
                display: flex;
                margin-bottom: 3vw;

                li {
                    font-size: 12pt;
                    margin-right: 5vw;
                }

                .active {
                    border-bottom: 2px solid;
                }
            }

            .bottom {
                li {
                    div {
                        font-size: 10pt;
                        line-height: 24px;
                    }

                    .title {
                        font-size: 12pt;
                        margin-top: 3vw;
                    }
                }

                .discountDesc {
                    font-size: 10pt;
                }

                .bg1,
                .bg2 {
                    width: 304px;
                    height: 380px;
                    padding: 0 10px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    div {
                        width: 100%;
                        text-align: center;
                        font-size: 14px !important;
                    }

                    div:first-child {
                        font-weight: bold;
                    }

                    .btn {
                        width: 200px;
                        height: 48px;
                        line-height: 48px;
                        background: black;
                        color: #fff;
                        text-align: center;
                        margin: 15px auto;
                    }
                }

                .bg1 {
                    background: url("../assets/img/bg1.svg") no-repeat center center;
                    background-size: cover;
                }

                .bg2 {
                    background: url("../assets/img/bg2.svg") no-repeat center center;
                    background-size: cover;
                }
            }
        }
    }

    .icon {
        /* 通过设置 font-size 来改变图标大小 */
        width: 2vw;
        /* 图标和文字相邻时，垂直对齐 */
        vertical-align: -0.15em;
        /* 通过设置 color 来改变 SVG 的颜色/fill */
        fill: black;
        /* path 和 stroke 溢出 viewBox 部分在 IE 下会显示
           normalize.css 中也包含这行 */
        overflow: hidden;
    }

    .line-through {
        text-decoration: line-through;
    }
}
</style>
